import { Controller } from "@hotwired/stimulus";

// Templates index — clicking "Utiliser" calls the instantiate endpoint and
// redirects to the freshly-created form's edit page.
export default class extends Controller {
  static values = {
    instantiateUrlTemplate: String,
    juniorId:               String,
    csrfToken:              String
  };

  async instantiate(event) {
    event?.preventDefault?.();
    const id = event.currentTarget.dataset.templateId;
    const name = event.currentTarget.dataset.templateName || "ce template";
    if (!id) return;
    if (!confirm(`Créer un nouveau formulaire à partir de « ${name} » ?`)) return;

    try {
      const res = await fetch(this.instantiateUrlTemplateValue.replace("__id__", id), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfTokenValue || (document.querySelector('meta[name="csrf-token"]')?.content || "")
        },
        credentials: "same-origin"
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error((data.errors || [data.error || "Création impossible"]).join(", "));
      }
      const form = await res.json();
      window.location.href = `/juniors/${this.juniorIdValue}/jestionform/forms/${form.id}/edit`;
    } catch (e) {
      alert(e.message);
    }
  }
}
